import type { SVGProps } from 'react';
const SvgForwardSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M22 0H2C.897 0 0 .897 0 2v20c0 1.103.897 2 2 2h20c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2zm0 22H2V2h20v20c.003 0 0 0 0 0z" />
    <path d="M20.5 3h-17c-.275 0-.5.225-.5.5v17c0 .275.225.5.5.5h17c.275 0 .5-.225.5-.5v-17c0-.275-.225-.5-.5-.5zM20 20H4V4h16v16z" />
    <path d="M8.256 14.937a.51.51 0 0 0 .51-.012L12 12.903V14.5c0 .181.1.35.256.438a.51.51 0 0 0 .51-.012l4-2.5a.503.503 0 0 0 0-.85l-4-2.5a.5.5 0 0 0-.762.426v1.597L8.77 9.077a.5.5 0 0 0-.762.426v5a.489.489 0 0 0 .25.438zM13 10.403 15.556 12 13 13.597v-3.194zm-4 0L11.556 12 9 13.597v-3.194z" />
  </svg>
);
export default SvgForwardSquare;
